import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app.component';
import { appConfig } from 'app.config';
import { config } from 'devextreme/common';
import { licenseKey } from '../devextreme-license';

config({
  licenseKey
});

registerLocaleData(localePt);

bootstrapApplication(AppComponent, {
  providers: [
    ...appConfig.providers,
    { provide: LOCALE_ID, useValue: 'pt-BR' } // Garantir que a localidade esteja configurada
  ]
}).catch(err => console.error(err));
